import { useEffect, useState } from "react";
import { Container, Row, Col, Pagination, Table } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import ShimmerLoader from "../utilComponents/shimmer.js";
import { usePayoutHistory } from "../../services/hooks/getApi";

const PayoutHistory = () => {
  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const { data: withdrawHistoryData, isLoading } = usePayoutHistory();
  useEffect(() => {
    if (Array.isArray(withdrawHistoryData)) {
      setWithdrawHistory(withdrawHistoryData ? withdrawHistoryData.reverse() : []);
    }
  }, [withdrawHistoryData]);

  // Pagination logic
  const paginatedHistory = withdrawHistory.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(withdrawHistory.length / itemsPerPage);

  return (
    <>
      <Container className="mt-4 custom-container">
        <Row>
          <Col>
            {/* <h5 className="text-center">Payout History</h5> */}
            <h4 className="text-center text-primary">Payout History</h4> <br />
            <Table striped bordered hover className="text-center">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Amount</th>
                  <th>Method</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                { isLoading ? (
                  <tr>
                    <td colSpan="9">
                      <ShimmerLoader width="100%" height="30px" />
                    </td>
                  </tr>
                ) : (
                  paginatedHistory.length > 0 ? (
                  paginatedHistory.map((withdraw, index) => (
                    <tr key={index}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>₹{withdraw?.amount}</td>
                      <td>{withdraw?.withdraw_mode}</td>
                      <td>
                        <span
                          className={`badge ${
                            withdraw?.status === "Approved"
                              ? "bg-success"
                              : withdraw.status === "Pending"
                              ? "bg-warning text-dark"
                              : "bg-danger"
                          }`}>
                          {withdraw.status}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9">No deposit requests found</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                <Pagination>
                  {[...Array(totalPages)].map((_, pageIndex) => (
                    <Pagination.Item
                      key={pageIndex}
                      active={currentPage === pageIndex + 1}
                      onClick={() => setCurrentPage(pageIndex + 1)}>
                      {pageIndex + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PayoutHistory;
